import { render, staticRenderFns } from "./CreateBrandsForm.vue?vue&type=template&id=3dc7a623&"
import script from "./CreateBrandsForm.vue?vue&type=script&lang=js&"
export * from "./CreateBrandsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports